import { createAsyncThunk } from '@reduxjs/toolkit';
import { actionTypes } from './constants';
import {
  checkOrganizationStatusApi,
  fetchMyOrganizationApi,
  fetchOrganizationByIdApi,
  createOrganizationApi,
  updateOrganizationApi,
  fetchMembersApi,
  inviteMemberApi,
  removeMemberApi,
  resendInvitationApi,
  deletePendingInvitationApi,
} from './api';
import type {
  CreateOrganizationPayload,
  UpdateOrganizationPayload,
  InviteMemberPayload,
} from './types';

export const checkOrganizationStatus = createAsyncThunk(
  actionTypes.CHECK_ORGANIZATION_STATUS,
  async (_, { getState }) => await checkOrganizationStatusApi(getState()),
);

export const fetchMyOrganization = createAsyncThunk(
  actionTypes.FETCH_MY_ORGANIZATION,
  async (_, { getState }) => await fetchMyOrganizationApi(getState()),
);

export const fetchOrganizationById = createAsyncThunk(
  actionTypes.FETCH_ORGANIZATION_BY_ID,
  async (organizationId: string, { getState }) =>
    await fetchOrganizationByIdApi(getState(), organizationId),
);

export const createOrganization = createAsyncThunk(
  actionTypes.CREATE_ORGANIZATION,
  async (payload: CreateOrganizationPayload, { getState }) =>
    await createOrganizationApi(getState(), payload),
);

export const updateOrganization = createAsyncThunk(
  actionTypes.UPDATE_ORGANIZATION,
  async (
    { organizationId, payload }: { organizationId: string; payload: UpdateOrganizationPayload },
    { getState },
  ) => await updateOrganizationApi(getState(), organizationId, payload),
);

export const fetchMembers = createAsyncThunk(
  actionTypes.FETCH_MEMBERS,
  async ({ organizationId, status }: { organizationId: string; status?: string }, { getState }) =>
    await fetchMembersApi(getState(), organizationId, status),
);

export const inviteMember = createAsyncThunk(
  actionTypes.INVITE_MEMBER,
  async (
    { organizationId, payload }: { organizationId: string; payload: InviteMemberPayload },
    { getState },
  ) => await inviteMemberApi(getState(), organizationId, payload),
);

export const removeMember = createAsyncThunk(
  actionTypes.REMOVE_MEMBER,
  async (
    { organizationId, memberId }: { organizationId: string; memberId: string },
    { getState },
  ) => await removeMemberApi(getState(), organizationId, memberId),
);

export const resendInvitation = createAsyncThunk(
  actionTypes.RESEND_INVITATION,
  async (
    { organizationId, memberId }: { organizationId: string; memberId: string },
    { getState },
  ) => await resendInvitationApi(getState(), organizationId, memberId),
);

export const deletePendingInvitation = createAsyncThunk(
  actionTypes.DELETE_PENDING_INVITATION,
  async (
    { organizationId, invitationId }: { organizationId: string; invitationId: string },
    { getState },
  ) => await deletePendingInvitationApi(getState(), organizationId, invitationId),
);
